import React from 'react';
import './FAQs.css'

const FAQs = () => {
  return (
    <section id="faqs" className="py-5">
        <h2>Frequently Asked Questions</h2>
        <p>Have questions? We've got answers. Check out the most frequently asked questions about our platform:</p>
        
        <div className="faq-card">
          <div className="faq-item">
            <h4>• How do I register for an auction?</h4>
            <div className="faq-answer">
              Simply sign up on the platform and follow the easy steps to create and manage your auction. 
              Registration is free and only takes a few minutes. Once registered, you can either create 
              your own auction or join an existing one as a team representative or spectator.
            </div>
          </div>
          
          <div className="faq-item">
            <h4>• What information do I need to create an auction?</h4>
            <div className="faq-answer">
              To create an auction, you'll need basic information such as the sport type, auction date and 
              time, default team budget. You can add more detailed information later, 
              including adding/updating teams and players, and specific auction rules.
            </div>
          </div>
          
          <div className="faq-item">
            <h4>• Can I modify my auction once it's live?</h4>
            <div className="faq-answer">
              Yes! Admins can update bids, teams, and other details during the live auction. Our platform 
              provides real-time editing capabilities while maintaining data integrity and transparency. 
              All changes are logged for audit purposes, ensuring fair play throughout the process.
            </div>
          </div>
          
          <div className="faq-item">
            <h4>• How do team budgets work?</h4>
            <div className="faq-answer">
              Each team is allocated a predetermined budget at the start of the auction. Our system 
              automatically tracks spending and prevents teams from exceeding their limits. Admins 
              can adjust budgets before the auction begins, and special budget rules can be configured 
              for different auction formats.
            </div>
          </div>
          
          <div className="faq-item">
            <h4>• What happens if there's a tie bid?</h4>
            <div className="faq-answer">
              Our platform includes configurable tie-breaking rules that can be set before the auction 
              begins. Options include lottery selection, team priority orders, or additional bidding 
              rounds. The specific tie-breaking mechanism is displayed to all participants before 
              the auction starts.
            </div>
          </div>
          
          <div className="faq-item">
            <h4>• Is Live Auction available for all sports?</h4>
            <div className="faq-answer">
              Currently, we focus on cricket and volleyball, but we plan to expand to more sports in the future. 
              Our platform is designed with flexibility in mind, allowing easy adaptation to different sports 
              with unique rules and requirements. Contact us if you're interested in using our platform for 
              a sport not currently supported.
            </div>
          </div>
          
          <div className="faq-item">
            <h4>• Can participants join from mobile devices?</h4>
            <div className="faq-answer">
              Yes, our platform is fully responsive and works seamlessly on smartphones, tablets, and 
              desktop computers. Team representatives can participate in real-time bidding from anywhere, 
              and spectators can follow the action on their preferred devices. The mobile experience 
              includes all features available on the desktop version.
            </div>
          </div>
          
          <div className="faq-item">
            <h4>• What happens if there's a technical issue during an auction?</h4>
            <div className="faq-answer">
              Our platform includes robust error handling and automatic recovery mechanisms. In the rare 
              event of a technical issue, auctions can be paused and resumed without losing data. We 
              maintain detailed logs of all transactions and provide backup systems to ensure continuity. 
              Our support team is available to assist with any technical difficulties during live events.
            </div>
          </div>
          
          
          <div className="faq-item">
            <h4>• How can I get support if I have issues?</h4>
            <div className="faq-answer">
              Our support team is available via email and live chat during business hours. Premium 
              subscribers receive priority support with faster response times. We also maintain a 
              comprehensive knowledge base with tutorials, best practices, and troubleshooting guides. 
              For urgent issues during live auctions, dedicated support is available 24/7 for premium users.
            </div>
          </div>
        </div>
    </section>
  );
};

export default FAQs;